import { UserPasswordRepository } from "@/domain/repository/user-password-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

/**
 * 웹 비밀번호 찾기용 이메일 인증코드 발급 유스케이스
 */
export class IssueWebFindSnEmailAuthCodeUsecase {
  constructor(private readonly userPasswordRepo: UserPasswordRepository) {}

  async execute(email: string): Promise<SATResult<string, SATError>> {
    const normalizedEmail = email.trim().toLowerCase();
    return this.userPasswordRepo.issueWebFindSnEmailAuthCode({
      loginId: normalizedEmail,
      email: normalizedEmail,
    });
  }
}
